import * as tslib_1 from "tslib";
import React from 'react';
import { SvgIcon } from '@nextiva/next-ui';
import funnelIcon from './funnel.svg';
import "./FunnelSvg.css";

var FunnelSvg = function FunnelSvg(props) {
  return React.createElement(SvgIcon, tslib_1.__assign({
    className: "funnel-svg",
    src: funnelIcon
  }, props));
};

export default FunnelSvg;